/**
 * OS.js - JavaScript Cloud/Web Desktop Platform
 *
 * Copyright (c) 2011-Present, Anders Evenrud <andersevenrud@gmail.com>
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
 * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
 * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 * @author  Anders Evenrud <andersevenrud@gmail.com>
 * @licence Simplified BSD License
 */

import appsIcon from "./icon.png";

// This is the client configuration tree.
// Guide: https://manual.aaronmeese.com/config/#client
// Complete config tree: https://github.com/meese-os/meeseOS/blob/master/frontend/client/src/config.js

const api_key = process.env.GOOGLE_API_KEY;
const client_id = process.env.GOOGLE_CLIENT_ID;
const quotes = require("./quotes.js");

export default {
	desktop: {
		settings: {
			background: {
				type: "dynamic",
				effect: "matrix",
			},
			widgets: [{ name: "digitalclock" }],
			icons: "We10XIcons",
		},
	},

	auth: {
		// Prevents the user from automatically logging in as "demo"
		login: {
			username: null,
			password: null,
		},
	},

	// Backed entirely by the browser, so the desktop needs no VFS server.
	// `meeseOS` is the shipped build output, read over HTTP against the
	// manifest that `meese-cli package:manifest` writes at build time, and
	// `home` is per-visitor storage in IndexedDB.
	//
	// NOTE: The whole array is replaced rather than merged, which is why
	// `index.js` builds the Core with `omit: ["mountpoints"]`. Without that,
	// deepmerge would concatenate these onto the defaults.
	vfs: {
		mountpoints: [
			{
				name: "apps",
				label: "Applications",
				adapter: "apps",
				icon: appsIcon,
				attributes: {
					visibility: "restricted",
					readOnly: true,
				},
			},
			{
				name: "meeseOS",
				label: "MeeseOS",
				adapter: "static",
				icon: { name: "folder-publicshare" },
				attributes: {
					readOnly: true,
				},
			},
			{
				name: "home",
				label: "Home",
				adapter: "indexeddb",
				icon: { name: "user-home" },
			},
		],
	},

	gis: {
		enabled: true,
		client: {
			// Adds the Google information from the `.env` file if it exists
			...(api_key && { api_key }),
			...(client_id && { client_id }),
		},
	},

	// Adds the quotes from the `quotes.js` file
	quotes: quotes,
};
